module.exports = __webpack_public_path__ + "img/snapdate.es.93b11772.png";